module.exports = __webpack_public_path__ + "img/competitive-analysis.d018c47e.png";